import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { SharedService } from '../../../shared/services/share.services';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { AssignUser } from '../../../models/centre/manage-user.model';
import { AssignUserPopupComponent } from './assign-user-popup.component';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { AssignUserService } from './assign-user.service';

@Component({
  selector: 'assign-user-list',
  templateUrl: './assign-user-list.component.html',
  providers: [AssignUserService]
})

export class AssignUserListComponent extends TMBDataTableComponent implements OnInit {
  public dataRow = new Array<AssignUser>();
  public filterData = { userName: '' };

  constructor(public utility: Utility,
    public assignUserService: AssignUserService,
    public dialogService: DialogService,
    public sharedService: SharedService) {
      super(sharedService);
  }

  ngOnInit() {
    this.setPage({ offset: 0 });
  }


  /**
  * Populate the table with new data based on the page number
  * @param page The page to select
  */
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    const param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1,
      userName: this.filterData.userName
    };
    this.assignUserService.getUnAssignedUserList(param).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          // update page info
          this.page.totalElements = data['totalRecords'];
          this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
          // update dataSource
          this.dataRow = data['list'];
        }
      }
    );
  }


  /**
   * Filter list by user name
   */
  onFilter() {
    this.setPage({ offset: 0 });

  }

  /**
   * Update user/permission information
   * @param string userId
   */
  onAddItem(id: string) {
    const data = {
      id: id,
    };
    this.dialogService.openComponentDialog(AssignUserPopupComponent, data).subscribe(result => {
      // if add user success then reload the list
      if (result) {
        this.reloadPage(this.page.pageNumber, this.dataRow, true);
      }
    });
  }
}





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/assign-user/assign-user-list.component.ts